/*****************************************************
AB - subscription-frontend-discount
*****************************************************/
/*
  Variante B del widget de suscripción de Stay AI.

  Nada de esto corre hasta que se cumplen las dos condiciones:

    1. Convert agregó la clase `ab-sub-discount-b` al <body>.
    2. La app de Stay AI ya pintó el widget en el DOM.

  La configuración (textos, iconos, código de descuento) llega desde
  `window.ABSubDiscountB`, que emite sections/main-product.liquid solo
  cuando el producto tiene selling plans.
*/
(function () {
  'use strict';

  var CFG = window.ABSubDiscountB;
  if (!CFG) return;

  var BODY_CLASS = 'ab-sub-discount-b';
  var READY_CLASS = 'ab-sub-discount-b--ready';
  var DONE_ATTR = 'data-ab-sub-b';
  var WRAPPER_SELECTOR =
    'label[for="purchaseTypeSubscription"] .stayai-purchase-label__wrapper';

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------------------------
     1. Esperar a Convert
     ------------------------------------------------------------------ */

  function whenActivated(callback) {
    if (document.body.classList.contains(BODY_CLASS)) {
      callback();
      return;
    }

    var settled = false;

    var observer = new MutationObserver(function () {
      if (settled || !document.body.classList.contains(BODY_CLASS)) return;
      settled = true;
      observer.disconnect();
      window.clearTimeout(timer);
      callback();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });

    // Si Convert nunca asigna la clase, el usuario se queda en la variante A.
    var timer = window.setTimeout(function () {
      settled = true;
      observer.disconnect();
    }, CFG.activationTimeout || 8000);
  }

  /* ------------------------------------------------------------------
     2. Reescritura del widget
     ------------------------------------------------------------------ */

  function buildIcon(src, className, size) {
    var img = document.createElement('img');
    img.className = className;
    img.src = src;
    img.alt = '';
    img.width = size;
    img.height = size;
    return img;
  }

  function rewriteTag(wrapper) {
    var tag = wrapper.querySelector('.stayai-subscription-tag');
    if (!tag) return;

    tag.textContent = '';

    var text = document.createElement('span');
    text.className = 'ab-sub-b__tag-text';
    text.textContent = CFG.text.tag;
    tag.appendChild(text);

    if (CFG.icons.tag) {
      tag.appendChild(buildIcon(CFG.icons.tag, 'ab-sub-b__tag-icon', 12));
    }
  }

  function rewriteLabel(wrapper) {
    var label = wrapper.querySelector('.subscription-label');
    if (!label) return;

    // rtx-pdp.js hace `savingLbl.textContent = …` sobre `.subscription-savings`
    // sin comprobar null (assets/rtx-pdp.js, updateProductPrice). Si borramos
    // ese nodo, el widget revienta en cada cambio de variante o de plan.
    // Lo conservamos: lo sacamos, vaciamos el título y lo devolvemos oculto.
    var savings = label.querySelector('.subscription-savings');
    if (!savings) {
      savings = document.createElement('span');
      savings.className = 'subscription-savings';
    }
    savings.classList.add('ab-sub-b__savings');

    label.textContent = '';

    var lead = document.createElement('span');
    lead.className = 'ab-sub-b__lead';
    lead.textContent = CFG.text.lead;
    label.appendChild(lead);

    var offer = document.createElement('span');
    offer.className = 'ab-sub-b__offer';
    offer.textContent = CFG.text.offer;
    label.appendChild(offer);

    if (CFG.icons.offer) {
      label.appendChild(buildIcon(CFG.icons.offer, 'ab-sub-b__offer-icon', 16));
    }

    label.appendChild(savings);
  }

  function rewriteDetails(wrapper) {
    var container = wrapper.querySelector('.stayai-subscription-details-container');
    if (!container) return;

    var list = document.createElement('ul');
    list.className = 'ab-sub-b__list';

    CFG.details.forEach(function (detail, index) {
      var item = document.createElement('li');
      item.className = 'ab-sub-b__item';

      if (detail.icon) {
        item.appendChild(buildIcon(detail.icon, 'ab-sub-b__item-icon', 24));
      }

      var text = document.createElement('span');
      text.className = 'ab-sub-b__item-text';
      text.setAttribute('data-ab-sub-b-detail', String(index));
      item.appendChild(text);

      list.appendChild(item);
    });

    container.textContent = '';
    container.appendChild(list);
  }

  // El % lo escribe la app, así que se relee en cada pasada en lugar de fijarlo.
  function refreshDetailText(wrapper) {
    var node = wrapper.querySelector('.subscription-savings');
    var savings = node ? node.textContent.trim() : '';
    if (!savings) savings = CFG.fallbackSavings || '';

    CFG.details.forEach(function (detail, index) {
      var slot = wrapper.querySelector('[data-ab-sub-b-detail="' + index + '"]');
      if (!slot) return;

      var html = detail.html.replace(/\{savings\}/g, escapeHtml(savings));
      if (slot.innerHTML !== html) slot.innerHTML = html;
    });
  }

  function transform(wrapper) {
    if (wrapper.getAttribute(DONE_ATTR) !== '1') {
      rewriteTag(wrapper);
      rewriteLabel(wrapper);
      rewriteDetails(wrapper);
      wrapper.setAttribute(DONE_ATTR, '1');
    }

    refreshDetailText(wrapper);
  }

  /* ------------------------------------------------------------------
     3. Código de descuento
     ------------------------------------------------------------------ */

  // Se aplica al ENTRAR a la variante B, no al agregar al carrito. La cookie de
  // descuento tiene que existir antes del /cart/add: si se pone después, las
  // secciones de carrito que Shopify ya devolvió vienen sin el descuento y no
  // se ve en el drawer hasta la siguiente actualización.
  function initDiscount() {
    var code = CFG.discountCode;
    if (!code) return;

    // Se pregunta por el estado real del carrito en vez de guardar una bandera
    // propia. Con bandera, si algo más quitaba el cupón (el JS de control de la
    // variante A, una prueba manual), la bandera seguía puesta y la variante B
    // ya nunca lo volvía a aplicar. Así se corrige solo, y ante la duda aplica
    // de más — que es inofensivo — en vez de aplicar de menos.
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        var applied =
          cart &&
          (cart.discount_codes || []).some(function (discount) {
            return (discount.code || '').toUpperCase() === code.toUpperCase();
          });

        if (applied) return;

        // Se redirige a /cart.js para no arrastrar el HTML completo de la home.
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
          credentials: 'same-origin',
        });
      })
      .catch(function () {
        /* sin red: se vuelve a intentar en la siguiente carga */
      });
  }

  /* ------------------------------------------------------------------
     4. Arranque
     ------------------------------------------------------------------ */

  function start() {
    // Primero el descuento: entre menos tarde la cookie, menos probable es que
    // el usuario alcance a dar Agregar al carrito antes de que esté puesta.
    initDiscount();

    var queued = false;

    function scan() {
      queued = false;

      var wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
      for (var i = 0; i < wrappers.length; i++) transform(wrappers[i]);

      if (wrappers.length) document.body.classList.add(READY_CLASS);
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(scan);
    }

    schedule();

    // El widget lo pinta la app y el Section Rendering API vuelve a
    // reemplazarlo en cada cambio de variante, así que se observa siempre.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
    });

    // rtx-pdp.js reescribe el % de ahorro al cambiar de plan o de variante.
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (
        target &&
        target.closest &&
        target.closest('.stayai-subscriptions, product-info')
      ) {
        window.setTimeout(scan, 60);
      }
    });

    // Red de seguridad: el CSS anti-flash de Convert oculta el widget hasta
    // que aparece READY_CLASS. Si el widget nunca llega a renderizarse, se
    // libera igual para no dejarlo invisible.
    window.setTimeout(function () {
      document.body.classList.add(READY_CLASS);
    }, CFG.readyTimeout || 5000);
  }

  function boot() {
    whenActivated(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
